// NOTE: Adding @sentry/react to the dependencies causes an error because of dependencies it installs.
// Our other sentry dependencies (@sentry/react-native) already install @sentry/react so we can ignore this error.
// eslint-disable-next-line import/no-extraneous-dependencies
import * as Sentry from "@sentry/react";

import logger from "../services/logger";

const FACEBOOK_PIXEL_EVENTS = {
  START_TRIAL: "StartTrial",
  PURCHASE: "Purchase",
};

// eslint-disable-next-line import/prefer-default-export
export function facebookPixelSendStartTrialEvent(): void {
  if (!window.fbq) {
    const errorForSentry = new Error("Conversion tracking error - Facebook Pixel is not loaded");
    Sentry.captureException(errorForSentry);
  } else {
    window.fbq("track", FACEBOOK_PIXEL_EVENTS.START_TRIAL);
  }
}

export function wereWeReferredFromStripeCheckout(referrer: string): boolean {
  return referrer.startsWith("https://buy.stripe.com/");
}

export function trackStripeCheckoutPurchaseEvent(documentReferrer: string): (() => void) | void {
  try {
    if (wereWeReferredFromStripeCheckout(documentReferrer)) {
      logger.info("We were referred from Stripe Checkout");

      const checkFacebookPixelAndFireEvent = (): boolean => {
        if (typeof window.fbq === "function") {
          logger.info("Facebook Pixel function (fbq) is available.");

          // Fire purchase event
          window.fbq("track", FACEBOOK_PIXEL_EVENTS.PURCHASE, {
            // NOTE: These fields are required by Facebook Pixel
            // We hardcode the rough value of an annual plan (the most popular) because the
            // actual value is not passed through (since we use Stripe's no-code payment links)
            value: 50,
            currency: "EUR",
          });
          logger.info("Facebook Pixel purchase event fired");
          return true;
        }
        logger.info("Facebook Pixel not loaded yet. Waiting...");
        return false;
      };

      // Try immediately
      if (!checkFacebookPixelAndFireEvent()) {
        logger.info("Facebook Pixel not loaded yet. Waiting...");

        // Set up polling to check for Facebook Pixel
        const intervalId = setInterval(() => {
          if (checkFacebookPixelAndFireEvent()) {
            clearInterval(intervalId);
            logger.info("Facebook Pixel loaded after waiting");
          }
        }, 500);

        // Clean up interval if component unmounts
        return () => clearInterval(intervalId);
      }
    }
  } catch (error) {
    logger.error("Error in Facebook Pixel tracking:", error);
    Sentry.captureException(error);
  }

  return undefined;
}
